import React from 'react';
import { STATUS_ABERTOS, STATUS_PAGOS, abrirBoletoFatura, abrirPixFatura, abrirComprovanteFatura } from './faturas-utils';

// Botões de boleto / PIX / comprovante, iguais para o titular e para o master.
const AcoesFatura = ({ fatura, api, children }) => (
  <div className="action-buttons">
    {STATUS_ABERTOS.includes(fatura.status) && (
      <>
        <button className="ib ib-blue" title="Ver boleto" onClick={() => abrirBoletoFatura(fatura)}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/>
          </svg>
          Boleto
        </button>
        <button className="ib ib-sky" title="Ver QR Code PIX" onClick={() => abrirPixFatura(api, fatura)}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="5" height="5" rx="1"/><rect x="16" y="3" width="5" height="5" rx="1"/>
            <rect x="3" y="16" width="5" height="5" rx="1"/>
            <path d="M21 16h-3a2 2 0 00-2 2v3"/><path d="M21 21v.01"/><path d="M12 7v3a2 2 0 01-2 2H7"/><path d="M3 12h.01"/><path d="M12 3h.01"/><path d="M12 16v.01"/><path d="M16 12h1"/><path d="M21 12v.01"/>
          </svg>
          PIX
        </button>
      </>
    )}
    {STATUS_PAGOS.includes(fatura.status) && (
      <>
        <span style={{ color: 'var(--c-ok)', fontWeight: 600, fontSize: '.8rem', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          Pago
        </span>
        <button className="ib ib-green" title="Ver comprovante de pagamento" onClick={() => abrirComprovanteFatura(api, fatura)}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
          </svg>
          Comprovante
        </button>
      </>
    )}
    {children}
  </div>
);

export default AcoesFatura;
